import React from "react";

const ErrorIcon = ({ size = 22, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M11 1.83333C5.94915 1.83333 1.83331 5.94916 1.83331 11C1.83331 16.0508 5.94915 20.1667 11 20.1667C16.0508 20.1667 20.1666 16.0508 20.1666 11C20.1666 5.94916 16.0508 1.83333 11 1.83333ZM10.3125 7.33333C10.3125 6.95749 10.6241 6.64583 11 6.64583C11.3758 6.64583 11.6875 6.95749 11.6875 7.33333V11.9167C11.6875 12.2925 11.3758 12.6042 11 12.6042C10.6241 12.6042 10.3125 12.2925 10.3125 11.9167V7.33333ZM11.8433 15.015C11.7975 15.1342 11.7333 15.2258 11.6508 15.3175C11.5591 15.4 11.4583 15.4642 11.3483 15.51C11.2383 15.5558 11.1191 15.5833 11 15.5833C10.8808 15.5833 10.7616 15.5558 10.6516 15.51C10.5416 15.4642 10.4408 15.4 10.3491 15.3175C10.2666 15.2258 10.2025 15.1342 10.1566 15.015C10.1108 14.905 10.0833 14.7858 10.0833 14.6667C10.0833 14.5475 10.1108 14.4283 10.1566 14.3183C10.2025 14.2083 10.2666 14.1075 10.3491 14.0158C10.4408 13.9333 10.5416 13.8692 10.6516 13.8233C10.8716 13.7317 11.1283 13.7317 11.3483 13.8233C11.4583 13.8692 11.5591 13.9333 11.6508 14.0158C11.7333 14.1075 11.7975 14.2083 11.8433 14.3183C11.8891 14.4283 11.9166 14.5475 11.9166 14.6667C11.9166 14.7858 11.8891 14.905 11.8433 15.015Z"
      fill="#F23F3F"
    />
  </svg>
);
export default ErrorIcon;
